//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueHorizontal from 'vue-horizontal'
import streams from '~/data/virtual_sports'

const ElementsVideo = () => import('../components/elements/video')

export default {
  nuxtI18n: {
    paths: {
      es: '/apuestas-virtuales'
    }
  },
  head() {
    return {
      script: [

      ]
    }
  },
  components: { VueHorizontal, ElementsVideo },
  computed: {
    tabs() {
      let sports = _.get(this.$store.state, 'sports', [])

      sports = _.filter(sports, { is_parent: 0 })
      sports = _.filter(sports, { category: 'virtual' })
      sports = _.filter(sports, function (o) {
        return o.event_count > 0
      })
      sports = _.sortBy(sports, ['position'])
      return sports
    },
    sportTabs() {
      return _.get(this.$store.state, 'games.homeTabs', [])
    }
  },
  watch: {
    '$route.query.event_id': {
      handler: function (value) {
        this.eventId = this.$route.query.event_id
      },
      deep: true,
      immediate: true
    },
    tabs: function (val) {
      if (!this.selectedTab && _.size(this.tabs)) {
        this.getHome()
      }
    }
  },
  data() {
    return {
      loading: true,
      display_content: false,
      eventId: null,
      stream: null,
      selectedSection: null,
      selectedTab: null,
      sports: [],
      playerOptions: null,
      main_page_content: {
        item001: {
          content: '<h1>Apuestas Virtuales en Bet777</h1>'
        },
        item002: {
          content: 'El universo de las apuestas virtuales ofrece un sinfín de posibilidades para apostar online con dinero real en juegos virtuales de distintas temáticas. La experiencia es de lo más parecida a la que se vive con nuestras apuestas deportivas, aunque aquí tendrás la posibilidad de poder apostar 24 horas al día y en el momento que prefieras, sin tener que esperar a una fecha y hora exacta como ocurre con los eventos en directo. Conocerás el resultado casi de inmediato.'
        },
        item003: {
          content: 'No es de extrañar que las apuestas virtuales online estén en pleno auge, porque gracias al avance de la tecnología, ahora la diversión es mucho mayor al disponer de más opciones, y muy distintas entre sí, a las que apostar. Además de partidos de fútbol, tenis o baloncesto, tendrás la oportunidad de apostar en competiciones tan originales como carreras de canicas o carreras de arrastre. Si ya tienes cuenta en Bet777, accede a ella y descubre todo lo que las apuestas virtuales pueden ofrecerte, si todavía no estás registrado, hazlo ahora y empieza a divertirte.'
        },
        item004: {
          content: '<h2>¿Qué son las apuestas en deportes virtuales?</h2>'
        },
        item005: {
          content: 'Las apuestas virtuales online son una experiencia única que mezcla la emoción de las apuestas online con la tecnología digital. Con ellas, los amantes del juego online tienen la oportunidad de predecir resultados en eventos o competiciones simuladas informáticamente, siendo el procedimiento de apuesta y el sistema de cuotas igual que el de las apuestas tradicionales. El resultado de estas viene determinado por un generador de números aleatorios (RNG) y son tan fiables como las apuestas online o cualquier juego de casino, como por ejemplo la <a href="' + this.$config.CASINO_API + '/ruletas">ruleta</a> o las <a href="' + this.$config.CASINO_API + '/slots-destacadas">slots online</a>, ya que los resultados están certificados y homologados por organismos oficiales que garantizan la seguridad y transparencia en los resultados. Justamente por esto, es muy importante que solo apuestes en sitios regulados y con licencia otorgada por la DGOJ, como es el caso de Bet777.'
        },
        item006: {
          content: '<h2>¿Cómo funcionan las apuestas en deportes virtuales?</h2>'
        },
        item007: {
          content: 'Los eventos virtuales se crean a partir de algoritmos y programas informáticos avanzados que determinan el resultado de las competiciones o encuentros. Para apostar, debes estar registrado y disponer de saldo en cuenta, de no ser así, deberás realizar un depósito a través de uno de los medios de pago disponibles. Podrás apostar dinero en el resultado de los eventos virtuales de la misma forma a como lo harías en un evento deportivo real, pero en el caso de los eventos virtuales, los resultados no están influenciados por factores externos como el clima o el rendimiento de los deportistas.'
        },
        item008: {
          content: 'Deberás escoger el evento deseado, analizar las estadísticas y diferentes cuotas que existen para este y hacer tu apuesta. Una vez lo hayas hecho, visualiza el partido o evento virtual por el que has apostado y descubrirás el resultado en unos minutos. Como en el caso de las apuestas deportivas tradicionales, en las apuestas deportivas virtuales también se debe apostar con absoluta responsabilidad.'
        },
        item009: {
          content: '<h2>Juegos virtuales disponibles en Bet777</h2>'
        },
        item010: {
          content: 'Una de las mayores ventajas de las apuestas virtuales es que los usuarios pueden apostar en una amplia variedad de juegos virtuales que garantiza que siempre encuentres algún evento que sea de tu gusto. En Bet777 vas a poder disfrutar de los siguientes:'
        },
        item011: {
          content: '<span style="text-decoration:underline">Penaltis:</span> Dos equipos se enfrentarán en una tanda de penaltis y tú podrás apostar por el ganador. Tienes varias opciones y posibilidades a tu alcance. Apostar en este juego virtual de penaltis es tan sencillo como divertido.'
        },
        item012: {
          content: '<span style="text-decoration:underline">Carrera de canicas:</span> ¡La carrera más divertida y original que puedas imaginar! Distintas canicas de colores compiten por ser la primera en una carrera con asombrosos obstáculos virtuales. ¡Elige tu color y apuesta para conocer si tu predicción es la ganadora!'
        },
        item013: {
          content: '<span style="text-decoration:underline">Ciclismo:</span> Si eres fan de La Vuelta, el Tour o el Giro, espera a conocer este juego de apuestas virtuales de carreras de bicis. Sus gráficos y dinamismo te sumergirán de lleno en el pelotón. ¡Visualiza al ciclista más rápido y apuesta por él!'
        },
        item014: {
          content: '<span style="text-decoration:underline">Carrera de coches:</span> Podrás apostar en una carrera de coches urbana. En la carrera de arrastre virtual, dos automóviles compiten lado a lado para tratar de cruzar la línea de meta antes que su rival. ¡Mira las cuotas y apuesta por uno!'
        },
        item015: {
          content: '<span style="text-decoration:underline">Fútbol:</span> Los forofos del deporte rey están de enhorabuena porque ahora, también es posible apostar en una liga virtual. Tienes distintas opciones de apuesta para que la diversión no pare. ¡Hay partidos durante las 24 horas del día!'
        },
        item016: {
          content: '<span style="text-decoration:underline">Virtual Football Pro:</span> Otra modalidad de competición virtual de fútbol en la que apostar por tu equipo favorito. ¡Vibrarás con cada gol! Mira posibilidades, estudia las cuotas y haz tu predicción. En tan solo unos minutos conocerás el resultado.'
        },
      }
    }
  },
  mounted() {
    this.getHome()
  },
  methods: {
    filterTabsBySlug(tabs, slug) {
      for (const key in tabs) {
        if (tabs[key].slug === slug || tabs[key].translated_slug === slug) {
          return tabs[key];
        }
      }
    },
    async getHome() {
      if (!this.selectedTab) {
        if (_.size(this.tabs)) {
          let slug = _.get(this.$route.params, 'slug')
          let current_tab
          if (slug !== undefined) {
            current_tab = this.filterTabsBySlug(this.tabs, slug)
          } else {
            current_tab =this.tabs[0]
          }
          await this.selectTab(current_tab)
        }
      }
    },
    async selectTab(tab) {
      this.selectedTab = tab.slug
      await this.$router.push(this.localePath({
        name: 'virtual-slug',
        params: {slug: tab.translated_slug, eventId: this.eventId}
      }))
      this.stream = _.find(streams, { slug: tab.slug })
      try {
        this.$refs.horizontal.refresh(console.log)
      } catch (e) {}

      if(_.get(this.stream, 'web')) {
        this.playerOptions = {
          // videojs and plugin options
          aspectRatio: "16:9",
          playsinline: true,
          autoplay: true,
          muted: true,
          sources: [
            {
              withCredentials: false,
              type: 'application/x-mpegURL',
              src: _.get(this.stream, 'web')
            }
          ],
          controlBar: {
            playToggle: false,
            captionsButton: false,
            chaptersButton: false,
            subtitlesButton: false,
            remainingTimeDisplay: false,
            fullscreenToggle: false,
            volumeBar: false,
            playbackRateMenuButton: false,
            timeDivider: false,
            durationDisplay: false
          },
          flash: { hls: { withCredentials: false } },
          html5: { hls: { withCredentials: false } }
        }
      }
      this.loading = false;
      emitter.on('events_loaded', () => {
        this.display_content = true;
      })
    }
  }
}
